import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import qs from "qs";
import { useEffect } from "react";

import { notEmpty } from "shared/lib/utils";

import { rosettaAtom } from "scmp-app/lib/rosetta";
import type { PostiesPageQueryParameters } from "scmp-app/pages/posties/index.page";
import { page as PostiesKidsPage } from "scmp-app/pages/posties/kids";

export const usePostiesParentsRedirect = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const router = useRouter();

  useEffect(() => {
    if (!notEmpty(asyncRosettaState) || asyncRosettaState?.status === "loading") return;
    const isSubscriptionEnabled =
      asyncRosettaState?.result?.contentServiceUserInfo?.isSubscriptionEnabled ?? false;
    if (isSubscriptionEnabled) return;

    const { pathname: postiesKidsPagePathname, query: postiesKidsPageQuery } =
      PostiesKidsPage.route({});

    const parsedQueryString = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    }) as unknown as PostiesPageQueryParameters;

    const redirectedURL = {
      pathname: postiesKidsPagePathname,
      query: {
        ...postiesKidsPageQuery,
        ...parsedQueryString,
      },
    };

    void router.replace(redirectedURL);
  }, [asyncRosettaState, router]);
};
